<div class="row">
  <div class="col-md-12">
    <emr-custom-dropdown identifier="lstSortFilter" name="lstSortFilter" [options]="sortList.list" labelCssClass="height-10" cssClass="default-dropdown"
      [(ngModel)]="selectedSort" (ngModelChange)="onSortSelectionChange()" optionsTextField="LocalizedText" optionsValueField="Value"></emr-custom-dropdown>
  </div>
</div>